import moment from 'moment'

export function getHomePlanTotal(item) {
  return Number(
    item?.amount?.quantityAmount
      ?? item?.dailyQuantityAmount?.quantityAmount
      ?? item?.viewQuantityAmount?.quantityAmount
      ?? 0,
  )
}

export function getHomePlanCompleted(item) {
  return Number(
    item?.amount?.completedQuantityAmount
      ?? item?.dailyQuantityAmount?.completedQuantityAmount
      ?? item?.viewQuantityAmount?.completedQuantityAmount
      ?? 0,
  )
}

export function getHomePlanUnit(item) {
  return item?.amount?.quantityUnit
    || item?.dailyQuantityAmount?.quantityUnit
    || item?.viewQuantityAmount?.quantityUnit
    || ''
}

function isHomePlanComplete(item) {
  const total = getHomePlanTotal(item)
  return total > 0 && getHomePlanCompleted(item) >= total
}

export function getPendingHomePlans(items = [], limit = 5) {
  return items
    .filter((item) => getHomePlanTotal(item) > 0 && !isHomePlanComplete(item))
    .slice(0, limit)
}

export function getRecentLogs(items = [], limit = 3) {
  return [...items]
    .sort((a, b) => moment(b.activityTime?.startOn).valueOf() - moment(a.activityTime?.startOn).valueOf())
    .slice(0, limit)
}

export function formatFocusTime(seconds) {
  if (seconds === undefined || seconds === null) return '—'
  const safeSeconds = Math.max(0, Number(seconds) || 0)
  const hours = Math.floor(safeSeconds / 3600)
  const minutes = Math.floor((safeSeconds % 3600) / 60)
  return hours > 0 ? `${hours}시간 ${minutes}분` : `${minutes}분`
}

export function truncateHomeSubjectName(value, maxLength = 10) {
  const text = String(value || '')
  const characters = Array.from(text)
  if (characters.length <= maxLength) return text
  return `${characters.slice(0, maxLength).join('')}…`
}
